import React from 'react';

interface AllergyWarningIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const AllergyWarningIcon: React.FC<AllergyWarningIconProps> = ({
  width = 20,
  height = 20,
  className = '',
  color = '#EBB700',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="アレルギー注意"
    >
      <g clipPath="url(#clip0_853_14671)">
        <path
          d="M17.0709 2.92883C15.2645 1.12098 12.7581 -0.000546675 10 1.99908e-07C7.24191 -0.000546675 4.73523 1.12098 2.92879 2.92883C1.12094 4.73527 -0.000585708 7.24191 2.29479e-07 10C-0.000585708 12.7581 1.12094 15.2648 2.92879 17.0712C4.73523 18.8791 7.24191 20.0006 10 20C12.7581 20.0006 15.2645 18.8791 17.0709 17.0712C18.879 15.2648 20.0005 12.7581 20 10C20.0005 7.24191 18.8791 4.73527 17.0709 2.92883ZM15.6045 4.39555C17.0405 5.83305 17.9253 7.80785 17.9259 10C17.9254 12.1921 17.0405 14.167 15.6045 15.6045C14.1667 17.0405 12.1918 17.9254 10 17.9259C7.80785 17.9254 5.83305 17.0405 4.39555 15.6045C2.95945 14.167 2.07465 12.1921 2.07406 10C2.07461 7.80789 2.95945 5.83305 4.39551 4.39555C5.83301 2.95949 7.80785 2.07465 9.99996 2.07406C12.1918 2.07469 14.1667 2.95949 15.6045 4.39555Z"
          fill={color}
        />
        <path
          d="M10.0001 12.9846C9.37625 12.9846 8.86523 13.4959 8.86523 14.1195C8.86523 14.743 9.37625 15.254 10.0001 15.254C10.6236 15.254 11.1349 14.743 11.1349 14.1195C11.1349 13.4959 10.6236 12.9846 10.0001 12.9846Z"
          fill={color}
        />
        <path
          d="M10.0006 12.1871C10.2558 12.1871 10.614 11.0597 10.706 10.7302C10.9922 9.7759 11.2274 8.47527 11.2274 7.39977C11.2274 6.11594 10.8692 4.74609 10.0006 4.74609C9.13137 4.74609 8.77344 6.1159 8.77344 7.39977C8.77344 8.47531 9.00898 9.77594 9.29512 10.7302C9.38715 11.0597 9.7448 12.1871 10.0006 12.1871Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_853_14671">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AllergyWarningIcon;
